import { render } from "./AutoModal.vue?vue&type=template&id=37918460&scoped=true"
import script from "./AutoModal.vue?vue&type=script&lang=js"
export * from "./AutoModal.vue?vue&type=script&lang=js"

import "./AutoModal.vue?vue&type=style&index=0&id=37918460&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37918460"]])

export default __exports__